import Properties from "../widgets/Properties";
import { Clues, ClueType } from "../../model/Clues";
import { Constants } from "../../constants";
import { GieliCoordinates, TileCoordinates, TileRectangle } from "../../../lib/runescape/coordinates";
import LightButton from "../widgets/LightButton";
import { C } from "../../../lib/ui/constructors";
import { util } from "../../../lib/util/util";
import { MethodPackManager } from "../../MethodPackManager";
import ContextMenu from "../widgets/ContextMenu";
import Dependencies from "../../dependencies";
import { FavouriteIcon } from "../nisl";
import { ConfirmationModal } from "../widgets/modals/ConfirmationModal";
import { EditMethodMetaModal, NewMethodModal } from "./MethodModal";
import { TileArea } from "../../../lib/runescape/coordinates/TileArea";
import { Notification } from "../NotificationBar";
import { SolvingMethods } from "../../model/SolvingMethods";
var hbox = C.hbox;
var spacer = C.spacer;
var span = C.span;
var ClueSpot = Clues.ClueSpot;
var natural_join = util.natural_join;
var plural = util.plural;
import { AugmentedMethod, MethodPack } from "../../model/MethodPack";
export class ClueProperties extends Properties {
    constructor(clue, edit_handler, include_header, alternative_index, manage_methods_button) {
        super();
        this.clue = clue;
        this.edit_handler = edit_handler;
        this.include_header = include_header;
        this.alternative_index = alternative_index;
        this.manage_methods_button = manage_methods_button;
        this.render_promise = null;
        this.render_promise = this.render();
    }
    async render() {
        if (this.include_header)
            this.row(ClueProperties.header(this.clue));
        function renderSolution(self, sol) {
            try {
                self.named("Solution", (() => {
                    switch (sol.type) {
                        case "dig":
                            return c(`<span><img src='assets/icons/cursor_shovel.png' class="inline-img"> Dig at ${TileCoordinates.toString(sol.spot)}</span>`);
                        case "search":
                            return c(`<span><img src='assets/icons/cursor_search.png' class="inline-img"> Search <span class="nisl-entity">${sol.entity}</span> at ${TileCoordinates.toString(TileRectangle.bl(sol.spot))}</span>`);
                        case "talkto":
                            return c(`<span><img src='assets/icons/cursor_talk.png' class="inline-img"> Talk to <span class="nisl-npc">${sol.npc}</span> near ${TileCoordinates.toString(TileArea.activate(sol.spots[self.alternative_index || 0].range).center())}</span>`);
                    }
                })());
                if (sol.type == "search" && sol.key) {
                    self.named("Key", c(`<span><span style="font-style: italic">${sol.key.instructions}</span> (${sol.key.answer})</span>`));
                }
            }
            catch (e) {
            }
        }
        switch (this.clue.clue.type) {
            case "scan":
                this.named("Area", c().text(`${this.clue.clue.scantext}`));
                this.named("Range", c().text(`${this.clue.clue.range}`));
                this.named("Spots", c().text(`${this.clue.clue.spots.length}`));
                break;
            case "compass":
                renderSolution(this, { type: "dig", spot: this.clue.spot, description: null });
                this.named("Total", c().text(`${this.clue.clue.spots.length}`));
                break;
            case "coordinates":
                this.named("Text", c().text(this.clue.clue.text[0]).css("font-style", "italic"));
                this.named("Coordinates", c().text(GieliCoordinates.toString(this.clue.clue.coordinates)));
                renderSolution(this, { type: "dig", spot: GieliCoordinates.toCoords(this.clue.clue.coordinates), description: null });
                break;
            case "simple":
            case "cryptic":
            case "anagram":
                this.named("Text", c().text(this.clue.clue.text[0]).css("font-style", "italic"));
                renderSolution(this, this.clue.clue.solution);
                break;
            case "map":
                this.row(c(`<div style="text-align: center"><img src="${this.clue.clue.image_url}" style="height: 180px; width: auto; max-width: 100%"></div>`));
                this.named("Transcript", c().text(this.clue.clue.text[0]));
                renderSolution(this, this.clue.clue.solution);
                break;
            case "emote":
                this.named("Text", c().text(this.clue.clue.text[0]).css("font-style", "italic"));
                this.named("Equip", c().text(natural_join(this.clue.clue.items, "and")));
                if (this.clue.clue.emotes.length > 1)
                    this.named("Emotes", c().text(natural_join(this.clue.clue.emotes, "then")));
                else
                    this.named("Emote", c().text(this.clue.clue.emotes[0]));
                this.named("Agent", c().text(this.clue.clue.double_agent ? "Yes" : "No"));
                break;
            case "skilling":
                this.named("Text", c().text(this.clue.clue.text[0]));
                this.named("Answer", c().text(this.clue.clue.answer));
                break;
        }
        if (this.clue.clue.challenge?.length > 0) {
            this.named("Challenge", c().append(...this.clue.clue.challenge.map(ClueProperties.render_challenge).map(s => s)));
        }
        const methods = await MethodPackManager.instance().get(this.clue);
        this.named("Methods", c().text(`${plural(methods.length, "method")} available`));
        if (this.manage_methods_button) {
            this.row(hbox(new LightButton("Manage Methods", "rectangle")
                .onClick(async (event) => {
                new ContextMenu(await ClueProperties.methodMenu(this.clue, this.edit_handler))
                    .showFromEvent(event);
            })).addClass("ctr-button-container"));
        }
        /*
        let methods = await this.methods.get(this.clue)
        this.header("Methods")
    
        if (methods.length > 0) {
            let grouped = lodash.groupBy(methods, e => e.pack.local_id)
    
            for (let methods_in_pack of Object.values(grouped)) {
                this.row(new MethodWidget(methods_in_pack, this.edit_handler))
            }
        } else {
            if (this.clue.spot) {
                this.row(c().text("No methods for this spot."))
            } else {
                this.row(c().text("No methods for this clue."))
            }
        }
    
        this.row(hbox(new LightButton("+ New Method", "rectangle").onClick(() => {
            this.edit_handler({
                clue: this.clue.clue,
                pack: null,
                method: SolvingMethods.init(this.clue)
            })
        })).addClass("ctr-button-container"))
    
         */
        return this;
    }
    rendered() {
        return this.render_promise;
    }
}
(function (ClueProperties) {
    var notification = Notification.notification;
    var Method = SolvingMethods.Method;
    function header(clue) {
        return hbox(span(`${ClueType.meta(clue.clue.tier).name} ${ClueType.meta(clue.clue.type).name} Step (Id ${clue.clue.id})`).css("font-weight", "bold"), spacer().css("min-width", "20px"), c(`<img class="icon" src='${clue.clue.tier ? ClueType.meta(clue.clue.tier).icon_url : ""}' title="${ClueType.pretty(clue.clue.tier)}" style="margin-right: 3px">`), c(`<img class="icon" src='${Constants.icons.types[clue.clue.type]}' title="${ClueType.pretty(clue.clue.type)}">`));
    }
    ClueProperties.header = header;
    async function methodMenu(clue, edit_handler) {
        const ms = await MethodPackManager.instance().get(clue);
        return {
            type: "submenu",
            text: "",
            children: [
                {
                    type: "basic",
                    text: "New Method",
                    handler: async () => {
                        const m = await new NewMethodModal(clue).do();
                        if (m?.created) {
                            edit_handler(m.created);
                        }
                    }
                },
                ...(await Promise.all(ms.map(async (m) => await methodSubMenu(m, edit_handler))))
            ]
        };
    }
    ClueProperties.methodMenu = methodMenu;
    async function methodSubMenu(m, edit_handler) {
        const favourite = await Dependencies.instance().app.favourites.getMethod(ClueSpot.toId(m.clue), false);
        const isFavourite = AugmentedMethod.isSame(favourite, m);
        const men = {
            type: "submenu",
            text: m.method.name,
            icon: () => new FavouriteIcon().set(isFavourite),
            children: [
                {
                    type: "basic",
                    text: isFavourite ? "Unset Favourite" : "Make Favourite",
                    icon: () => new FavouriteIcon().set(isFavourite),
                    handler: () => {
                        Dependencies.instance().app.favourites.setMethod(ClueSpot.toId(m.clue), isFavourite ? undefined : m);
                    }
                },
            ]
        };
        if (MethodPack.isEditable(m.pack)) {
            men.children.push({
                type: "basic",
                text: "Edit",
                icon: "/assets/icons/edit.png",
                handler: () => edit_handler(m)
            });
            men.children.push({
                type: "basic",
                text: "Edit Metadata",
                icon: "/assets/icons/edit.png",
                handler: async () => {
                    const result = await new EditMethodMetaModal(m.clue, Method.meta(m.method), false).do();
                    if (result?.result) {
                        Method.setMeta(m.method, result.result);
                        MethodPackManager.instance().updateMethod(m);
                    }
                }
            });
        }
        men.children.push({
            type: "basic",
            icon: "/assets/icons/copy.png",
            text: "Edit Copy",
            handler: async () => {
                const new_method = await new NewMethodModal(m.clue, m).do();
                if (new_method?.created) {
                    edit_handler(new_method.created);
                }
            }
        });
        if (MethodPack.isEditable(m.pack)) {
            men.children.push({
                type: "basic",
                text: "Delete",
                icon: "/assets/icons/delete.png",
                handler: async () => {
                    const really = await new ConfirmationModal({
                        body: "Are you sure you want to delete this method? There is no way to undo it!",
                        options: [
                            { kind: "neutral", text: "Cancel", value: false },
                            { kind: "cancel", text: "Delete", value: true },
                        ]
                    }).do();
                    if (really) {
                        MethodPackManager.instance().deleteMethod(m);
                        notification("Deleted").show();
                    }
                }
            });
        }
        if (MethodPack.isEditableDefault(m.pack)) {
            men.children.push({
                type: "basic",
                text: m.method.is_default_override ? "Unset as Overridden Default" : "Set as Overridden Default",
                icon: () => new FavouriteIcon().set(m.method.is_default_override),
                handler: async () => {
                    if (m.method.is_default_override) {
                        m.method.is_default_override = false;
                    }
                    else {
                        const all = await MethodPackManager.instance().getForClue(m.method.for, [m.pack.local_id]);
                        all.forEach(other => {
                            if (!AugmentedMethod.isSame(other, m)) {
                                other.method.is_default_override = undefined;
                                MethodPackManager.instance().updateMethod(other);
                            }
                        });
                        m.method.is_default_override = true;
                    }
                    MethodPackManager.instance().updateMethod(m);
                }
            });
        }
        return men;
    }
    ClueProperties.methodSubMenu = methodSubMenu;
    function render_challenge(challenge) {
        switch (challenge.type) {
            case "wizard":
                return c(`<div><img src='assets/icons/cursor_attack.png' class="inline-img"> Wizard</div>`);
            case "slider":
                return c(`<div><img src='assets/icons/slider.png' class="inline-img"> Puzzle box</div>`);
            case "celticknot":
                return c(`<div><img src='assets/icons/celticknot.png' class="inline-img"> Celtic Knot</div>`);
            case "lockbox":
                return c(`<div><img src='assets/icons/lockbox.png' class="inline-img"> Lockbox</div>`);
            case "towers":
                return c(`<div><img src='assets/icons/towers.png' class="inline-img"> Towers Puzzle</div>`);
            case "challengescroll":
                return c(`<div><img src='assets/icons/cursor_talk.png' class="inline-img"> <span style="font-style: italic">${challenge.question}</span> (Answer: ${natural_join(challenge.answers.map(a => a.note ? `${a.answer} (${a.note}` : a.answer), "or")})</div>`);
        }
    }
    ClueProperties.render_challenge = render_challenge;
})(ClueProperties || (ClueProperties = {}));
